export default __webpack_public_path__ + "static/media/add_language.fdebb9ed.jpg";